import { render, staticRenderFns } from "./AssignCode.vue?vue&type=template&id=1c177ab3&lang=pug"
import script from "./AssignCode.vue?vue&type=script&lang=js"
export * from "./AssignCode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports